import { render, staticRenderFns } from "./bernhard-huber.vue?vue&type=template&id=190a79fc&scoped=true"
import script from "./bernhard-huber.vue?vue&type=script&lang=js"
export * from "./bernhard-huber.vue?vue&type=script&lang=js"
import style0 from "./bernhard-huber.vue?vue&type=style&index=0&id=190a79fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190a79fc",
  null
  
)

export default component.exports